// deviation_gruser TODO: create a lib for this
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import axios from 'axios';
import { call, select } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { CANCEL } from 'redux-saga';
const configReduxKey = '@@config';
const getConfigKey = (name)=>(state)=>{
        var _state_configReduxKey;
        return (_state_configReduxKey = state[configReduxKey]) === null || _state_configReduxKey === void 0 ? void 0 : _state_configReduxKey[name];
    };
const CANONICAL_XHR_ENDPOINT = 'https://www.deviantart.com/_napi/shared_api/';
const LOCAL_XHR_ENDPOINT = 'https://www.deviantart.lan/_napi/shared_api/';
function getFakeResponse(response) {
    if (process.env.NODE_ENV === 'test') {
        return response;
    }
    return new Promise((resolve)=>{
        setTimeout(()=>resolve(response), 1000);
    });
}
function getApiResponse(options) {
    const cancelTokenSource = axios.CancelToken.source();
    const promise = axios.request(options.enableCancellation ? _object_spread_props(_object_spread({}, options), {
        cancelToken: cancelTokenSource.token
    }) : options).then((response)=>{
        return response.data;
    }).catch(()=>{
        return false;
    });
    // redux saga calls this special prop when it cancel the outer saga E.g. takeLatest
    if (options.enableCancellation) {
        promise[CANCEL] = ()=>cancelTokenSource.cancel();
    }
    return promise;
}
export function isApiError(response) {
    return response.error || response.errorCode;
}
export function* request(options, fakeResponse) {
    if (options.baseURL === undefined) {
        // Handle prod vs local endpoint routing
        if (process.env.NODE_ENV !== 'production' || process.env.XHR_ENV === 'vm') {
            options.baseURL = yield select(getConfigKey('sharedApiBasePath'));
        // Local full docker helper
        } else if (window['__XHR_LOCAL__']) {
            options.baseURL = LOCAL_XHR_ENDPOINT;
        // Production goes to the xhr server
        } else {
            options.baseURL = CANONICAL_XHR_ENDPOINT;
        }
    }
    // CSRF
    const csrf = yield select(getConfigKey('csrfToken'));
    if (options.method && options.method.toLowerCase() === 'post') {
        if (options.data === undefined) {
            options.data = {};
        }
        options.data['csrf_token'] = csrf;
    } else {
        if (options.params === undefined) {
            options.params = {};
        }
        options.params['csrf_token'] = csrf;
    }
    const withCreds = yield select(getConfigKey('withCredentials'));
    if (withCreds) {
        options.withCredentials = true;
    }
    let result;
    // Using node env so we strip for prod bundle sdf sdf sdf
    if (process.env.NODE_ENV !== 'production') {
        if (fakeResponse !== undefined) {
            const doFake = yield select(getConfigKey('fakeApiRequests'));
            if (doFake) {
                ddt.log('saga', `Faked XHR for: ${options.url}`, options, fakeResponse(options));
                result = yield call(getFakeResponse, fakeResponse(options));
                return result;
            }
        }
    }
    result = yield call(getApiResponse, options);
    return result;
}
